import { useLogGoodsAnalyticsEvent } from '../../../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import { useGoodsDetail } from '../../../../../queries/useGoodsDetail';
import { getNumberRange, isNil } from 'shared/src/utils';

export const useLogClickShareGoods = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsDetail } = useGoodsDetail();
  return useCallback(() => {
    if (isNil(goodsDetail)) return;

    logGoodsAnalytics({
      name: 'CLICK_SHARE_GOODS',
      analytics: {
        REVIEW_COUNT: goodsDetail.goods.score.total_review_count,
        REVIEW_COUNT_RANGE: getNumberRange({
          target: goodsDetail.goods.score.total_review_count ?? 0,
          rangeUnit: 50,
        }),
      },
    });
  }, [goodsDetail, logGoodsAnalytics]);
};
